/**
 * Checks if Yotpo is enabled based on environment variables
 * @returns true if all required Yotpo environment variables are set
 */
export const isYotpoEnabled = (): boolean =>
  !!(
    process.env.NEXT_PUBLIC_YOTPO_STAR_RATING_ID &&
    process.env.NEXT_PUBLIC_YOTPO_SPACE_ID &&
    process.env.NEXT_PUBLIC_YOTPO_REVIEWS_ID
  );
